/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React from 'react'
import DashboardIcon from '@material-ui/icons/DashboardOutlined'
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import MotorcycleOutlinedIcon from '@material-ui/icons/MotorcycleOutlined';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';
import StarHalfOutlinedIcon from '@material-ui/icons/StarHalfOutlined';
import HomeWorkOutlinedIcon from '@material-ui/icons/HomeWorkOutlined';
import AddShoppingCartOutlinedIcon from '@material-ui/icons/AddShoppingCartOutlined';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import InputIcon from '@material-ui/icons/Input'
import ViewListIcon from '@material-ui/icons/ViewList';
import PhonelinkSetupIcon from '@material-ui/icons/PhonelinkSetup';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import CreateIcon from '@material-ui/icons/Create';
import FiberNewIcon from '@material-ui/icons/FiberNew';
import AlarmOnIcon from '@material-ui/icons/AlarmOn';
import ListAltIcon from '@material-ui/icons/ListAlt';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';


import {FormattedMessage} from "react-intl"
import __ from "src/admin-utils/LanguageHelper";

export default [
  {
    // subheader: __(' لوحة التحكم', 'Dashboard'),
    items: [
      {
        title: __('طلبات جديدة', 'Live Orders'),
        href: '/dashboard',
        icon: RadioButtonCheckedIcon,
      },
    ]
  },
  {
    subheader: __('ادارة التطبيق', 'App Management'),
    items: [

      {
        title: __('العملاء', 'Clients'),
        href: '/clients',
        icon: AssignmentIndOutlinedIcon
      },
      {
        title: __('السائقين', 'Drivers'),
        href: '/drivers',
        icon: MotorcycleOutlinedIcon,
      },
      // {
      //   title: __('العروض', 'Offers'),
      //   href: '/offers',
      //   icon: LocalOfferOutlinedIcon,
      // },
      // {
      //   title: __('الاشعارات', 'Notifications'),
      //   href: '/settings/notifications',
      //   icon: NotificationsActiveIcon
      // },
      // {
      //   title: __('التقييمات', 'Ratings'),
      //   href: '/ratings',
      //   icon: StarHalfOutlinedIcon
      // },
      // {
      //   title: __('الحجوزات', 'Reservation'),
      //   href: '/reservation',
      //   icon: ViewListIcon
      // },
    ]
  },
  {
    subheader: __('ادارة الطلبات', 'Orders Management'),
    items: [
      // {
      //   title: __('طلبات جديدة', 'New Orders'),
      //   href: '/orders/new',
      //   icon: FiberNewIcon,
      // },
      // {
      //   title: __('طلبات قيد التحضير', 'Processing Orders'),
      //   href: '/orders/processing',
      //   icon: AlarmOnIcon,
      // },
      {
        title: __('طلبات قيد التوصيل', 'Delivery Orders'),
        href: '/orders/delivery',
        icon: HomeWorkOutlinedIcon,
      },
      {
        title: __('ارشيف الطلبات', 'Orders Archive'),
        href: '/orders/all',
        icon: ListAltIcon,
      },
    ]
  },
  {
    subheader: __('الاعدادات', 'Settings'),
    items: [
      {
        title: __('الفروع', 'Branches'),
        href: '/branches',
        icon: AccountTreeIcon
      },
      {
        title: __('اعدادات التطبيق', 'App Settings'),
        href: '/settings/app',
        icon: PhonelinkSetupIcon
      },
    ]
  },
  {
    subheader: __('ادارة المستخدمين', 'User Management'),
    items: [
      {
        title: __('الادوار', 'Roles'),
        href: '/user/management/roles',
        icon: CreateIcon,
      },
      {
        title: __('الاعضاء', 'Users'),
        href: '/user/management/users',
        icon: GroupAddIcon,
      },
    ]
  },
  {
    items: [
      {
        title: __('تسجيل الخروج', 'Log Out'),
        href: '/auth/login',
        icon: InputIcon,
        alwaysShow: true
      },
    ]
  },
]
